import Vue from 'vue'

// App root component
export const App = Vue.component(
  'App',
  require('_/components/App/App.vue').default
)

// Assets component
export const Assets = Vue.component(
  'Assets',
  require('_/components/Assets/Assets.vue').default
)

// User interface components
export const MainMenu = Vue.component(
  'MainMenu',
  require('_/components/UserInterface/MainMenu/MainMenu.vue').default
)

export const LicenseExpiringNotification = Vue.component(
  'LicenseExpiringNotification',
  require('_/components/UserInterface/LicenseExpiringNotification/LicenseExpiringNotification.vue')
    .default
)

export const UserMenu = Vue.component(
  'UserMenu',
  require('_/components/UserInterface/UserMenu/UserMenu.vue').default
)

// Common components
export const Breadcrumb = Vue.component(
  'Breadcrumb',
  require('_/components/UserInterface/Breadcrumb/Breadcrumb.vue').default
)

export const HelpBlock = Vue.component(
  'HelpBlock',
  require('_/components/UserInterface/HelpBlock/HelpBlock.vue').default
)

export const Instructions = Vue.component(
  'Instructions',
  require('_/components/UserInterface/Instructions/Instructions.vue').default
)

export const Sidebar = Vue.component(
  'Sidebar',
  require('_/components/UserInterface/Sidebar/Sidebar.vue').default
)

export const TitleBlock = Vue.component(
  'TitleBlock',
  require('_/components/TitleBlock/TitleBlock.vue').default
)

export const TitleBar = Vue.component(
  'TitleBar',
  require('_/components/Dashboard/TitleBar/TitleBar.vue').default
)

export const QuickLaunch = Vue.component(
  'QuickLaunch',
  require('_/components/Dashboard/QuickLaunch/QuickLaunch.vue').default
)

export const SessionModal = Vue.component(
  'SessionModal',
  require('_/components/SessionModal/SessionModal.vue').default
)

export const SchedulePublishingModal = Vue.component(
  'SchedulePublishingModal',
  require('_/components/UserInterface/SchedulePublishingModal/SchedulePublishingModal.vue')
    .default
)

// export const DashboardWidgets = require('_/components/Dashboard/DashboardWidgets/DashboardWidgets.vue').default;

// Admin components
export const EntryForm = Vue.component(
  'EntryForm',
  require('_/components/UserInterface/EntryForm/EntryForm.vue').default
)

export const InfoPanel = Vue.component(
  'InfoPanel',
  require('_/components/UserInterface/InfoPanel/InfoPanel.vue').default
)
